<mat-card class="slidecontent">
  <div class="headcontent">

    <div class="pophead">
      <h3>Add Task </h3>
      <button mat-icon-button class="close">
        <mat-icon (click)="closeCreate(createClose)">close</mat-icon>
      </button>
    </div>
  </div>

  <div class="dialog_content">
    <form class="fix-mat-form-field">



      <div class="block">


        <div class="selectTaskColor">
          <div class="selectedColor" (click)="toggleColorSelection()" >
            <span [ngStyle]="{'background-color': selectedColor }"></span> 
            <mat-icon>arrow_drop_down</mat-icon>
          </div>
          <div class="colGroup" *ngIf="showColorPannel">
          <ng-container *ngFor="let color of colors; let i as index">
           
            <label class="colm"  [ngStyle]="{'background-color': color.colname }" >
              <input type="radio" id="{{i}}" type="radio" value="{{color.colname}}" (click)="myFunction(color.colname)" name="noteColor"  >
              <span class="checkmark"></span>
            </label>
          </ng-container>
        </div>
        </div>

        <mat-form-field class="">
          <mat-label>Title</mat-label>
          <input matInput placeholder="Task Name" value="See how easy it is to customize Copper ">
        </mat-form-field>

        <div class="extrnalTask">
          <mat-checkbox color="primary">External Task</mat-checkbox>
        </div>

      </div>

      <div class="block">

        <mat-form-field>
          <mat-label>Description</mat-label>
          <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10"></textarea>
        </mat-form-field>
      </div>


      <div class="block">
        <div class="subtaskHolder">
          <div class="rep">
            <div class="start">
              <mat-icon>subdirectory_arrow_right</mat-icon>
            </div>
            <!-- <mat-checkbox></mat-checkbox> -->
            <mat-form-field class="example-full-width">
              <mat-label>Subtask</mat-label>
              <input matInput placeholder="Add Subtask Name" value="First need to create profile">
            </mat-form-field>
          

            <button mat-icon-button class="remove">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
          <div class="rep">
            <div class="start">
              <mat-icon>subdirectory_arrow_right</mat-icon>
            </div>
            <!-- <mat-checkbox></mat-checkbox> -->
            <mat-form-field class="example-full-width">
              <mat-label>Subtask</mat-label>
              <input matInput placeholder="Add Subtask Name" value="Add people as a contact">
            </mat-form-field>
          
            <button mat-icon-button class="remove">
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
        </div>

        <button class="subtask" (click)="showSubTask()" mat-button color="primary">
          <mat-icon>add</mat-icon> Subtask
        </button>

      </div>

    
        
        <div class="doubleBlock">
        <div class="blockHold">
          <div class="tname">
            <mat-form-field>
              <mat-label>Task Action</mat-label>
              <mat-select value="">
                <mat-option value="">Phone</mat-option>
                <mat-option value="">Email</mat-option>
                <mat-option value="">Meeting</mat-option>
                <mat-option value="">Form</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="blockHold">
          <div class="tname">
            <mat-form-field>
              <mat-label>Priority</mat-label>
              <mat-select value="">
                <mat-option value="">High</mat-option>
                <mat-option value="">Medium</mat-option>
                <mat-option value="">Low</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </div>


     


      

  

      

      

    </form>
  </div>


  <div class="actionBtn">

    <button mat-flat-button class="cancel" (click)="closeCreate(createClose)">Cancel</button>
    <button mat-flat-button class="calltoaction" type="submit" color="primary">Add</button>
  </div>

</mat-card>

<div class="overlay" (click)="closeCreate(createClose)"></div>